import { render } from "./ProductSelector.vue?vue&type=template&id=42c38cf6&scoped=true"
import script from "./ProductSelector.vue?vue&type=script&lang=js"
export * from "./ProductSelector.vue?vue&type=script&lang=js"

import "./ProductSelector.vue?vue&type=style&index=0&id=42c38cf6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-42c38cf6"

export default script